import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  
  h1 {
    flex: 1;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  gap: 4px;

  .selected-period {
    font-family: 'ManropeRegular', sans-serif;
    font-style: normal;
    font-size: 11px;
    color: ${(props) => props.theme.colors.inactive};
    cursor: default;
    margin-top: 30px;
    position: absolute;
    z-index: 10;
    transition: opacity 0.5s ease-in-out;
    opacity: 0;
  }

  &:hover {
    .selected-period {
      opacity: 1;
    }
  }
`;

const VerticalDivider = styled.div`
  width: 0px;
  height: 40px;
  border: 1px solid #3C3C3C;
`;

export default { Wrapper, InnerWrapper, VerticalDivider };
